module.exports = __webpack_public_path__ + "static/img/merch.abe7b88.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/merch.jpeg
// module id = hifI
// module chunks = 1